import styles from './Timeline.module.scss'

const pointColors = {
  gray: '#DBDCDD',
  blue: '#3891FF',
  yellow: '#17D220'
}

export const Timeline = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.timeline}>{children}</div>
  </div>
)

export const Line = ({ form, range }) => (
  <div className={styles.lineHolder}>
    <div className={form === 'dotted' ? styles.lineDotted : styles.lineSolid}></div>
    {range && <div className={styles.range}>{range}</div>}
  </div>
)

export const Point = ({ primary, secondary, color = 'gray' }) => (
  <div className={styles.point}>
    <Dot color={color} />
    {
      <div
        className={[
          styles.pointTexts,
          color === 'empty' ? styles.transparentText : ''
        ].join(' ')}
      >
        {' '}
        <span className={styles.pointPrimary}>{primary}</span>
        <span className={styles.pointSecondary}>{secondary}</span>
      </div>
    }
  </div>
)

const Dot = ({ color }) => {
  if (color === 'deleted') {
    return (
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 0C2.9055 0 0 2.9055 0 6.5C0 10.0945 2.9055 13 6.5 13C10.0945 13 13 10.0945 13 6.5C13 2.9055 10.0945 0 6.5 0ZM9.75 8.8335L8.8335 9.75L6.5 7.4165L4.1665 9.75L3.25 8.8335L5.5835 6.5L3.25 4.1665L4.1665 3.25L6.5 5.5835L8.8335 3.25L9.75 4.1665L7.4165 6.5L9.75 8.8335Z"
          fill="#FF5D5D"
        />
      </svg>
    )
  }

  if (color === 'empty') {
    return (
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="6.29956"
          cy="6.65811"
          r="5.15082"
          stroke="#CCCFD2"
          strokeOpacity="1"
          strokeWidth="1.28771"
        />
      </svg>
    )
  }

  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.11328" cy="6.02509" r="6" fill={pointColors[color]} />
    </svg>
  )
}
